<p class="message-paragraph">{{ content.text }}</p>

